module.exports = __webpack_public_path__ + "img/listupicon.0c0302d0.svg";